import React from "react";

import styles from "./FormHeader.module.css";
import {CloseImageButton} from "../closeImageButton/CloseImageButton";


interface ModalHeaderProps {
    formTitle: string
    onClose: () => any;
}

export const FormHeader: React.FC<ModalHeaderProps> = ({
                                                           formTitle,
                                                           onClose
                                                       }) => {

    return <div className={styles.header}>
        <span className={styles.title}>{formTitle}</span>
        <CloseImageButton onClose={onClose}/>
    </div>

}
